module.exports = __webpack_public_path__ + "static/media/sendnudes.45308eee.gif";